import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [showTop, setShowTop] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-20 pb-14 md:pb-0">{children}</main>
      <SiteFooter />

      {/* 移动端底部固定操作栏 */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50/95 backdrop-blur border-t border-background-200 flex items-center justify-around h-14">
        <Link
          to="/"
          className="flex flex-col items-center gap-0.5 text-foreground-700 text-[11px] cursor-pointer"
        >
          <i className="ri-home-5-line text-lg" />
          首页
        </Link>
        <Link
          to="/category/电视剧"
          className="flex flex-col items-center gap-0.5 text-foreground-700 text-[11px] cursor-pointer"
        >
          <i className="ri-tv-2-line text-lg" />
          剧集
        </Link>
        <Link
          to="/search"
          className="flex flex-col items-center gap-0.5 text-foreground-700 text-[11px] cursor-pointer"
        >
          <i className="ri-search-line text-lg" />
          搜索
        </Link>
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex flex-col items-center gap-0.5 text-foreground-700 text-[11px] cursor-pointer"
        >
          <i className="ri-arrow-up-line text-lg" />
          顶部
        </button>
      </div>

      {/* 桌面返回顶部 */}
      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="hidden md:flex fixed bottom-8 right-8 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-xl" />
        </button>
      )}
    </div>
  );
}